

import React from 'react';
import HeaderComponent from '../../Shared/header.shared';
import FooterComponent from '../../Shared/footer.shared';

const BlogScreen: React.FC = () => {
 
  return (
    <>
      <HeaderComponent theme="light" />
      <section className="page page--iframe">
       <iframe src="https://siticsoftware.com/blog/" width="100%" height="100%" frameBorder="0" className="iframe-window"/>
      </section>
      <FooterComponent />
    </>
  );
};

export default BlogScreen;
